// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// Substitua pelos valores do seu projeto Supabase
const supabaseUrl = 'https://pigwnaqczeshlndxvtpi.supabase.co'; // Ex.: https://seu-projeto.supabase.co
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBpZ3duYXFjemVzaGxuZHh2dHBpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ0ODM1MTUsImV4cCI6MjA2MDA1OTUxNX0.CaQax1nvkJNBJhoMhJ9BsmWbJsrA8IsEohKETynGoBs'; // Encontrada no dashboard do Supabase

export const supabase = createClient(supabaseUrl, supabaseKey);